module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-helper', [_c('div', {
    attrs: {
      "slot": "form-header"
    },
    slot: "form-header"
  }, [_c('h2', {
    staticClass: "grey--text text--darken-2"
  }, [_vm._v("Stammdaten")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-fields"
    },
    slot: "form-fields"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3'),
      expression: "'required|min:3'"
    }],
    attrs: {
      "name": "name",
      "label": "Name",
      "error": _vm.errors.has('name'),
      "id": "firmaname"
    },
    model: {
      value: (_vm.fa.name),
      callback: function($$v) {
        _vm.$set(_vm.fa, "name", $$v)
      },
      expression: "fa.name"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "small red--text"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "namezusatz",
      "label": "Namezusatz",
      "id": "firmanamezusatz"
    },
    model: {
      value: (_vm.fa.namezusatz),
      callback: function($$v) {
        _vm.$set(_vm.fa, "namezusatz", $$v)
      },
      expression: "fa.namezusatz"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "telefon",
      "label": "Telefon",
      "error": _vm.errors.has('telefon'),
      "id": "firmatelefon"
    },
    model: {
      value: (_vm.fa.telefon),
      callback: function($$v) {
        _vm.$set(_vm.fa, "telefon", $$v)
      },
      expression: "fa.telefon"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('telefon')),
      expression: "errors.has('telefon')"
    }],
    staticClass: "small red--text"
  }, [_vm._v(_vm._s(_vm.errors.first('telefon')))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "fax",
      "label": "Fax",
      "id": "firmafax"
    },
    model: {
      value: (_vm.fa.fax),
      callback: function($$v) {
        _vm.$set(_vm.fa, "fax", $$v)
      },
      expression: "fa.fax"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "name": "email",
      "label": "eMail",
      "id": "firmaemail",
      "error": _vm.errors.has('email')
    },
    model: {
      value: (_vm.fa.email),
      callback: function($$v) {
        _vm.$set(_vm.fa, "email", $$v)
      },
      expression: "fa.email"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "small red--text"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "web",
      "label": "Web",
      "id": "firmaweb"
    },
    model: {
      value: (_vm.fa.web),
      callback: function($$v) {
        _vm.$set(_vm.fa, "web", $$v)
      },
      expression: "fa.web"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-commands"
    },
    slot: "form-commands"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.submitted
    }
  }, [_c('v-icon', {
    staticClass: "green--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("done")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/firmen",
      "exact": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("close")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2875a70","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/firmen/createFirmen_1.vue
// module id = 347
// module chunks = 0